import React from "react";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import store from "../../../../appStore";

const Location = ({ location }) => {
  const { t } = useTranslation();
  const snap = useSnapshot(store);

  const handleChange = (location) => {
    if (snap.locations.includes(location) && snap.locations.length > 1) {
      store.locations = snap.locations.filter((loc) => loc !== location);
    } else if (!snap.locations.includes(location)) {
      store.locations.push(location);
    } else if (snap.locations.length === 1) {
      return null;
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        height: "3.5vh",
        pointerEvents: "auto",
      }}
      className="locationWrapper"
    >
      <input
        className="location-checkbox"
        type="checkbox"
        id={location.name}
        name={location.name}
        value={location.name}
        onChange={() => handleChange(location.name)}
        checked={snap.locations.includes(location.name)}
      />
      <label
        htmlFor={location.name}
        style={{
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignContent: "center",
          alignItems: "center",
          cursor: snap.locations.length === 1 && snap.locations.includes(location.name) ? "not-allowed" : "pointer",
        }}
      >
        <img
          src={location.image}
          alt={location.name}
          style={{
            width: "1vw",
            height: "1vw",
            margin: "0 0.75vw",
          }}
        />
        <p
          style={{
            // wordWrap: "break-word",
            width: "max-content",
            maxWidth: "8vw",
          }}
        >
          {t(location.translationKey)}
        </p>
      </label>
    </div>
  );
};

export default Location;
